/*
 *   This content is licensed according to the W3C Software License at
 *   https://www.w3.org/Consortium/Legal/2015/copyright-software-and-document
 *
 *   Simple accordion pattern example
 */

"use strict";

class Card {
    constructor(domNode) {
        this.card = domNode;

        this.buttonPostuler = this.card.querySelector(".card-offer__buttons span");

        if (this.buttonPostuler) {
            const dataLink = this.buttonPostuler.getAttribute("data-link");
            if (dataLink) {
                this.linkPostuler = atob(dataLink);
                this.buttonPostuler.addEventListener("click", this.onButtonClick.bind(this));
            }
        }
    }

    onButtonClick() {
        window.location.href = this.linkPostuler;
    }
}

// init cards
const cards = document.querySelectorAll(".card-offer");
cards.forEach((card) => {
    new Card(card);
});
